const headRowsUsers = {
  name: 'Nombre',
  email: 'E-mail',
  role: 'Tipo de Acceso',
  site: 'Sitios',
  lastLogin: 'Último Acceso'
};

export default headRowsUsers;
